<div *ngIf="listItem" class="file-row noselect"
     [class.file-row-single]="singleRow" [class.center75]="!singleRow"
     [class.is-selected]="!listItem.isFriend && !listItem.isMyReferral && !listItem.isTrainer && listItem.isSelected"
     [class.is-focused]="!listItem.isFriend && !listItem.isMyReferral && !listItem.isTrainer && listItem.isInFocus"
     (contextmenu)="handleContextMenu($event)" (dblclick)="handleDbClick($event)">
  <div *ngIf="!listItem.isNotAccessible && listItem.isClient"
       class=""
       matBadge="{{listItem.itemFullData.bonus_points}}" matBadgeColor="warn">
    <img alt="" title="{{listItem.name}}. {{listItem.itemFullData.bonus_points}} points."
      src="{{listItem.picture_ava}}" class="list-item-image"
      style="{{ listItem.itemFullData.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
    />
  </div>
  <div *ngIf="!listItem.isNotAccessible && (listItem.isFriend || listItem.isMyReferral)"
       class=""
       matBadge="{{listItem.itemFullData.rank}}" matBadgeColor="accent">
    <img alt="" title="{{listItem.name}}. {{listItem.itemFullData.rank}} points."
      src="{{listItem.picture_ava}}" class="list-item-image"
      style="{{ listItem.itemFullData.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
    />
  </div>
  <div *ngIf="!listItem.isNotAccessible && listItem.isTrainer">
    <img alt="" title="{{listItem.name}}"
      src="{{listItem.picture_ava}}" class="list-item-image"
      style="{{ listItem.itemFullData.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
    />
  </div>
  <!--<mat-icon *ngIf="!listItem.isNotAccessible && listItem.isClient" class="file-icon accent-icon">assignment_ind</mat-icon>-->
  <mat-icon *ngIf="!listItem.isNotAccessible && listItem.isDirectory" class="file-icon accent-icon">folder</mat-icon>
  <mat-icon *ngIf="!listItem.isNotAccessible && listItem.isStorage" class="file-icon accent-icon">storage</mat-icon>
  <mat-icon *ngIf="!listItem.isNotAccessible && listItem.isShared" class="file-icon accent-icon">folder_shared</mat-icon>
  <mat-icon *ngIf="!listItem.isNotAccessible && listItem.isFile" class="file-icon">insert_drive_file</mat-icon>
  <mat-icon *ngIf="listItem.isError" class="file-icon error-state">report_problem</mat-icon>
  <mat-spinner *ngIf="listItem.isPending" color="accent"
               class="file-icon accent-icon" [diameter]="24"></mat-spinner>

  <div class="file-name noselect" [class.error-state]="listItem.isError">
    <ng-container *ngIf="listItem.showWarning">⚠ </ng-container>
    {{listItem.name}}<br/>
    <span class="subrow" *ngIf="listItem.isClient">
      <span *ngIf="listItem.itemFullData.native_group?.status === 'client'">
        <b>Client groups:</b> {{listItem.itemFullData.classes | ClientClassesPipe}}
      </span>
      <span *ngIf="listItem.itemFullData.native_group?.status !== 'client'">
        {{listItem.itemFullData.native_group?.status}}
      </span>
      <ng-container *ngIf="listItem.itemFullData['shipping_phone']">
        <br>
        <span>
          {{ listItem.itemFullData['shipping_phone'] | phoneFormatter }}
        </span>
      </ng-container>
    </span>
    <div class="subrow flex-row-center" *ngIf="listItem.isFriend && listItem['itemFullData']['relation_params']['__class']">
      <mat-icon>groups</mat-icon>&nbsp;&nbsp;&nbsp;
      <div style="white-space: break-spaces;">{{listItem['itemFullData']['relation_params']['__class']['name']}}</div>
    </div>
    <div class="subrow flex-row-center" *ngIf="(listItem.isMyReferral || listItem.isMyFriendReferral) && !listItem['itemFullData']['relation_params']['__class']">
      <mat-icon>people_outline</mat-icon>&nbsp;&nbsp;&nbsp;
      <div style="white-space: break-spaces;">{{'your_referral_title'|GetLabelPipe}}</div>
    </div>
    <div class="subrow subrow-trainer flex-row-center" *ngIf="listItem.isTrainer">
      <mat-icon style="width: 16px;">phone</mat-icon>&nbsp;&nbsp;&nbsp;+{{listItem['itemFullData']['shipping_phone']}}
    </div>
  </div>
  <div class="file-size hidden-xs hidden-md">
    {{listItem.itemFullData.bonus_points}} points
  </div>
  <div *ngIf="!listItem.isStorage && !listItem.isFriend && !listItem.isMyReferral && !listItem.isTrainer" class="file-date">
    {{listItem.cdate | fsDate}}
  </div>
  <div *ngIf="!listItem.isStorage" class="file-menu">
    <button *ngIf="listItem.isSnapshot" mat-icon-button (click)="handleFileMenuClick($event)"
            [matMenuTriggerFor]="snapshotMenu">
      <mat-icon>more_horiz</mat-icon>
    </button>
    <button *ngIf="!listItem.isNotAccessible && !listItem.isSnapshot && !listItem.isFriend && !listItem.isMyReferral && !listItem.isTrainer" mat-icon-button (click)="handleFileMenuClick($event)"
            [matMenuTriggerFor]="fileMenu">
      <mat-icon>more_horiz</mat-icon>
    </button>
    <button *ngIf="!listItem.isNotAccessible && listItem.isTrainer" mat-icon-button
            [matMenuTriggerFor]="trainerMenu">
      <mat-icon>more_horiz</mat-icon>
    </button>
    <app-relation-button *ngIf="listItem.isFriend || listItem.isMyReferral" [listItem]="listItem"></app-relation-button>
<!--    <div *ngIf="listItem.isFriend" matRipple class="flex-column-center column-button">-->
<!--      <mat-icon>person_add</mat-icon>-->
<!--      <div>Add as friend</div>-->
<!--    </div>-->
    <div class="empty-file-menu" *ngIf="listItem.isStorage || listItem.isNotAccessible"></div>
  </div>
</div>

<mat-menu #snapshotMenu="matMenu" class="file-menu">
  <div class="items-counter" *ngIf="activeItemCounter > 1">SELECTED
    {{activeItemCounter}} ITEMS</div>
  <button *ngIf="operationsAllowed?.isRestoreAllowed" mat-menu-item (click)="handleRestore()">
    <mat-icon>backup</mat-icon> Restore in original place
  </button>
  <button *ngIf="operationsAllowed?.isCopyInBufferAllowed" mat-menu-item (click)="handleCopyInBuffer()">
    <mat-icon>content_copy</mat-icon> Copy in buffer
  </button>
</mat-menu>

<mat-menu #fileMenu="matMenu" class="file-menu">
  <div class="items-counter" *ngIf="activeItemCounter > 1">SELECTED
    {{activeItemCounter}} ITEMS</div>
<!--  <button (click)="handleReportDownload()" mat-menu-item>-->
<!--    <mat-icon>file_download</mat-icon>-->
<!--    Points report-->
<!--  </button>-->
  <button (click)="profileInfo()" mat-menu-item>
    <mat-icon>info</mat-icon>
    User info
  </button>
  <button (click)="showPurchases(listItem)" mat-menu-item>
    <mat-icon>add_shopping_cart</mat-icon>
    {{'user_services' | GetLabelPipe}}
  </button>
  <button (click)="showPurchases(listItem, 'show_proposals')" mat-menu-item>
    <mat-icon>celebration</mat-icon>
    {{'user_proposals' | GetLabelPipe}}
  </button>
  <button (click)="showReferrals(listItem)" mat-menu-item>
    <mat-icon>group_add</mat-icon>
    User referrals
  </button>
  <button (click)="handleZeroPoints()" mat-menu-item>
    <mat-icon>card_giftcard</mat-icon>
    Update bonus points
  </button>
  <hr>
  <ng-container *ngIf="listItem.itemFullData['native_group'] && ['trainer','owner'].includes(listItem.itemFullData['native_group']['status'])">
    <button (click)="trainerSetup(listItem)" mat-menu-item>
      <mat-icon>paid</mat-icon>
      Trainer pricing
    </button>
    <hr>
  </ng-container>
  <button mat-menu-item (click)="handleRename()">
    <mat-icon>edit</mat-icon> Rename
  </button>
  <button mat-menu-item (click)="handleDelete()">
    <mat-icon color="warn">delete</mat-icon> Delete
  </button>
</mat-menu>

<mat-menu #trainerMenu="matMenu" class="file-menu">
  <button mat-menu-item>
    <mat-icon>info</mat-icon> Full contact details
  </button>
  <button mat-menu-item (click)="handleTrainerBooking()" *ngIf="!singleRow">
    <mat-icon>history</mat-icon> Book trainer
  </button>
</mat-menu>
